module.exports = __webpack_public_path__ + "img/work_from_anywhere4.88136d4d.png";